export default __webpack_public_path__ + "static/media/graph-down.d900fda2.svg";